import { coursesSearchValidator } from "@/validators/courses";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { COURSE_STATUS } from "@vixi/types";
import z from "zod";

const courseStatusCount = Object.keys(COURSE_STATUS).length / 2;

export const Route = createFileRoute("/admin/courses/")({
  validateSearch: zodValidator(
    coursesSearchValidator.extend({
      status: z
        .number()
        .int()
        .min(0)
        .max(courseStatusCount - 1)
        .optional(),
    })
  ),
  loaderDeps: (search) => search,
});
